import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from './Icons';
export function GuaranteeSection() {
  return <section className="py-10 md:py-20 px-4 bg-sage-light relative overflow-hidden" data-id="element-54">
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 opacity-20" data-id="element-55">
        <div className="absolute top-[-20%] right-[-10%] w-[50%] h-[50%] rounded-full bg-sage blur-[120px]" data-id="element-56"></div>
      </div>

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-57">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white rounded-3xl p-8 md:p-12 shadow-xl border-2 border-sage/30 text-center" data-id="element-58">
          <div className="inline-flex items-center justify-center p-4 bg-sage-light rounded-full mb-6" data-id="element-59">
            <ShieldCheck className="w-12 h-12 text-sage" data-id="element-60" />
          </div>

          <h2 className="text-3xl md:text-4xl font-serif font-bold text-navy mb-6" data-id="element-61">
            La Garantía "Mamá Feliz"
          </h2>

          <div className="w-16 h-1 bg-sage mx-auto mb-8 rounded-full" data-id="element-62"></div>

          <p className="text-xl text-warm-dark leading-relaxed mb-6" data-id="element-63">
            Pruébalo por <strong data-id="element-64">7 días</strong>. Si tu hijo no empieza a jugar
            de forma más autónoma y las peleas por el Wi-Fi no disminuyen,
            mándame un email.
          </p>

          <p className="text-xl text-warm-dark leading-relaxed mb-8" data-id="element-65">
            Te devuelvo cada centavo de tus $13.99 y te quedas con el material.{' '}
            <strong className="text-sage bg-sage-light px-2 py-1 rounded" data-id="element-66">
              El riesgo es 100% mío.
            </strong>
          </p>
        </motion.div>
      </div>
    </section>;
}